import { el } from '../../core/dom.js';
import {
  initials, pageOf, planLabel, unreadLabel,
} from './model.js';

function calendarIcon() {
  return el('svg', {
    width: '16',
    height: '16',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-linecap': 'square',
    'aria-hidden': 'true',
  }, el('path', { d: 'M4 6h16v14H4zM4 10h16M8 3v5M16 3v5' }));
}

export function renderHeader(onCreate) {
  return el('header', { class: 'org-head' },
    el('div', { class: 'org-head-copy' },
      el('h1', { class: 'org-title' }, 'Every tenant, ', el('em', {}, 'one view.')),
      el('p', {}, 'Manage tenant organizations, their seats, plans and connector health.')),
    el('button', {
      type: 'button',
      class: 'org-cta',
      onClick: onCreate,
    }, 'Add Organization', el('span', { class: 'org-arw', 'aria-hidden': 'true' }, '→')));
}

function orgRow(row, selectedId, onSelect, delay) {
  const on = row.id === selectedId;
  const unread = unreadLabel(row.unread_messages);
  return el('button', {
    type: 'button',
    class: on ? 'org-row is-on' : 'org-row',
    style: delay ? `animation-delay:${delay}s` : null,
    'aria-pressed': on ? 'true' : 'false',
    onClick: () => onSelect(row.id),
  },
  el('span', { class: on ? 'org-av is-on' : 'org-av', 'aria-hidden': 'true' }, initials(row.name)),
  el('span', { class: 'org-row-copy' },
    el('span', { class: 'org-row-name' }, row.name || 'Organization'),
    el('span', { class: 'org-row-meta' }, planLabel(row.plan))),
  unread
    ? el('span', { class: 'org-unread', 'aria-label': `${unread} unread` }, unread)
    : (on ? el('span', { class: 'org-dot', 'aria-hidden': 'true' }) : null));
}

export function renderSidebar(state, handlers) {
  const page = pageOf(state.filtered, state.shown);
  const rows = page.rows.map((row, i) => orgRow(
    row,
    state.view === 'org' ? state.selectedId : '',
    handlers.onSelect,
    0.18 + (i * 0.05),
  ));
  let body;
  if (state.listLoading) body = el('div', { class: 'org-side-empty' }, 'Loading organizations…');
  else if (!state.filtered.length) {
    body = el('div', { class: 'org-side-empty' },
      el('strong', {}, 'No organizations'),
      el('p', {}, state.search ? 'Try a different search.' : 'Add an organization to get started.'));
  } else {
    body = el('div', { class: 'org-rows' },
      rows,
      page.more ? el('button', {
        type: 'button',
        class: 'org-more',
        onClick: handlers.onMore,
      }, `Load more · ${page.remaining} left`) : null);
  }

  return el('aside', { class: 'org-side', 'aria-label': 'Organizations list' },
    el('button', {
      type: 'button',
      class: state.view === 'calendar' ? 'org-avail is-on' : 'org-avail',
      onClick: handlers.onCalendar,
    }, calendarIcon(), 'Availability'),
    el('label', { class: 'org-search' },
      el('span', { class: 'sr-only' }, 'Search organizations'),
      el('input', {
        class: 'org-input',
        type: 'search',
        placeholder: 'Search organizations…',
        value: state.search || '',
        onInput: (event) => handlers.onSearch(event.target.value),
      })),
    body);
}
